import { scheduledDateFormat } from "@const/formats";
import formatWithLocale from "@helpers/formatWithLocale";

export default (scheduleTime, scheduleDate, scheduleTimezone) => {
  const time = `0${scheduleTime}`.slice(-5);

  const scheduledDate = `${formatWithLocale(
    new Date(scheduleDate),
    scheduledDateFormat,
  )}T${time}${scheduleTimezone.slice(5, 11)}`;

  const scheduledTimeZoneName = scheduleTimezone.split(" ").at(-1);

  return {
    scheduledDate,
    scheduledTimeZoneName,
  };
};
